import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '../../../hooks/@lore/query-connect';
import ReminderDialogTemplate from '../_common_reminders/ReminderDialogTemplate';

Dialog.propTypes = {
  evaluationEventEducator: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { evaluationEventEducator } = props;

  const reminders = useConnect('reminder.find', {
    where: {
      eager: {
        $where: {
          evaluationEventEducatorId: evaluationEventEducator.id
        }
      }
    }
  });

  const user = useConnect('user.byId', {
    id: evaluationEventEducator.data.userId
  });

  let _data = {
    evaluationEventEducatorId: evaluationEventEducator.id,
    recipientId: user.id,
    type: 'Complete'
  };

  return (
    <ReminderDialogTemplate
      title="Send reminder to complete evaluation"
      subtitle={(
        <span>
          This will send an email to {user.data.firstName} nudging them to complete the evaluation.
        </span>
      )}
      reminders={reminders}
      _data={_data}
      MAX_COUNT={2}
      onClose={props.onClose}
      blockerText={evaluationEventEducator.data.completed && (
        <div className="text-base text-cs-gray-700">
          Evaluation has been completed. Sending a reminder is not allowed.
        </div>
      )}
    />
  );
};
